import { createClient } from '@supabase/supabase-js'
import { Database } from './types/supabase'
import { getWorkosAccessToken } from './models/useAuth'

const env = import.meta.env

/**
 * Supabase client configured to send WorkOS JWT for RLS
 * Uses accessToken callback to provide dynamic JWT from auth model
 */
export const supabase = createClient<Database>(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: false, // Don't use Supabase auth storage
      autoRefreshToken: false, // We handle refresh via router
    },
    accessToken: async () => {
      // Return WorkOS JWT for RLS, or null if not authenticated
      const token = getWorkosAccessToken()
      return token ?? null
    },
  }
)
